/**
 * Enrolled PAL uses the parallel `*pal-ifp*` host; prod uses `loan.payrailzprod.com` for both guest and enrolled.
 */
export default function guestLoanUrlToEnrolledPalIfpUrl(input) {
  if (!input || typeof input !== 'string') {
    return input;
  }
  const trimmed = input.trim();
  if (!/^https?:\/\//i.test(trimmed)) {
    return input;
  }
  try {
    const u = new URL(trimmed);
    const { hostname } = u;

    if (/pal-ifp\.payrailz/i.test(hostname)) {
      return u.origin;
    }

    if (/\.loan\.payrailzprod\.com$/i.test(hostname)) {
      return u.origin;
    }

    const replaced = hostname.replace(
      /\.(dev\d|qa\d|imp\d|uat\d|conv)loan\.(payrailzdev|payrailztest)\.com$/i,
      '.$1pal-ifp.$2.com'
    );
    if (replaced !== hostname) {
      return `https://${replaced}`;
    }

    return u.origin;
  } catch (_e) {
    return input;
  }
}
